import clsx from 'clsx'
import { FormKey } from '../utils/validateForm'
import { CSSProperties } from 'react'

export type FieldProps = Pick<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  'type' | 'placeholder' | 'disabled'
> & {
  name: FormKey
  description?: string
  defaultValue?: string
  label?: string
  required?: boolean
  error?: string
  style?: CSSProperties
}

export function Field(props: FieldProps) {
  const {
    name,
    description,
    placeholder,
    label,
    required,
    error,
    style,
    ...rest
  } = props

  return (
    <div className='field' style={style}>
      {label && (
        <label htmlFor={name}>
          {label}
          {required && (
            <span className='required' aria-label='required'>
              {' '}
              *
            </span>
          )}
        </label>
      )}
      {description && <p className='description'>{description}</p>}
      <input
        name={name}
        placeholder={placeholder}
        className={clsx({ error: error })}
        {...rest}
      />
      {error && <span className={clsx({ error: error })}>{error}</span>}
    </div>
  )
}
